var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.855,
    height: 32.777,
    viewBox: "0 0 40.855 32.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ae236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8acd2e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "house",
    d: "M1778.976,660.447v-2.407h4V642.634h2.5v15.406H1810.5V642.634h2.5v15.406h3.5v2.407Zm20.517-6.259v-2.407h3v2.407Zm-6,0v-2.407h3v2.407Zm6-6.74v-2.407h3v2.407Zm-6,0v-2.407h3v2.407ZM1777,639.982l6.164-3.607h-.185V628.9a1.268,1.268,0,0,1,1.308-1.189h5.383a1.274,1.274,0,0,1,1.316,1.189v2.755l6.328-3.78c.9-.535-.3-.97,20.541,11.8l-1.344,2.035-18.582-11.372L1778.314,642Zm8.481-5.13,3-1.712v-3.024h-3Z",
    transform: "translate(-1777 -627.67)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.08930be3.svg";
export { ForwardRef as ReactComponent };